import React from "react";
import styles from "./styles.css";
import loadable from "@loadable/component";
import PropTypes from "prop-types";
import Modal from "../../shared/modal";
import closeButton from "./images/close-icon.svg";
import InputMobile from "../../shared/input-mobile";
import Button from "../../shared/button";
import CheckoutLoginWhatsappRevamp from "../checkout-login-whatsapp-revamp";
import CountdownTimer from "../../shared/countdown-timer";
import { Link } from "react-router-dom";
import LogoComponent from "../../shared/logo/component";
import InputOTP from "../../shared/input-otp";
import useToggle from "../../../hooks/use-toggle";
import { TU_CIBIL_PDF } from "../../../constants/cf-constants";
import { bifrost } from "../../../utils/get-bifrost-instance";
const TermsOfUsePopup = loadable(() => import("../terms-of-use-popup"));

const LoginControl = ({
    onClose,
    showOtpField,
    custPhone,
    otp,
    otpRef,
    phoneRef,
    toggleRef,
    showLoader,
    isNextDisabled,
    onPhoneChange,
    onOtpChange,
    onGetOTP,
    allowWhatsapp,
    errorMessage,
    onWhatsappChange,
    onOtpVerify,
    showResendOtp,
    onCompleteTimer,
    setShowOtpField,
    isOTPInvalid,
    setErrorMessage,
    isEditable,
    overlayClass = "loginOverlay"
}) => {
    const [showCibilConsent, setShowCibilConsent] = useToggle(false);

    const getHeading = () => {
        return (
            <h2>
                <span>Log in</span> to <br /> continue
            </h2>
        );
    };

    const handleClose = () => {
        onClose();
        setErrorMessage(null);
    };

    const onRequestOTP = () => {
        onGetOTP();
    };

    const handleEdit = () => {
        setShowOtpField(false);
    };

    const onClickTermsOfUse = () => {
        setShowCibilConsent();
    };

    return showCibilConsent ? (
        <TermsOfUsePopup onClick={setShowCibilConsent} />
    ) : (
        <Modal isOpen={true} overlayClass={overlayClass}>
            <div styleName={"styles.modalWrap"}>
                <span styleName={"styles.close"}>
                    <img src={closeButton} alt="close" onClick={handleClose} />
                </span>
                <div styleName={"styles.leftPanel"}>
                    <LogoComponent />
                    <h4>
            A whole new <br /> world of Cars
                    </h4>
                </div>
                <div styleName={"styles.rightPanel"}>
                    {getHeading()}

                    {!showOtpField ? (
                        <React.Fragment>
                            <div styleName={"styles.formWrap"}>
                                <h4 styleName={"styles.heading"}>Mobile number</h4>
                                <div styleName={"styles.formGroup"}>
                                    <InputMobile
                                        isPrefixAsFixed={true}
                                        isLabelShift={false}
                                        placeholder="999 999 9999"
                                        inputRef={phoneRef}
                                        value={custPhone}
                                        onChange={onPhoneChange}
                                        disabled={!isEditable}
                                    />
                                </div>
                                <div styleName={"styles.whatsappWrap"}>
                                    <CheckoutLoginWhatsappRevamp
                                        toggleRef={toggleRef}
                                        onWhatsappToggle={onWhatsappChange}
                                        checked={allowWhatsapp}
                                    />
                                </div>

                                <Button
                                    disabled={isNextDisabled}
                                    onClick={onRequestOTP}
                                    text="GET OTP"
                                    isLoading={showLoader}
                                />
                            </div>
                            <div styleName={`styles.messageWrap styles.messageText`}>
                                <React.Fragment>
                                    <p>By logging in, you agree to Cars24's</p>
                                    <ul>
                                        <li>
                      Cars24’s Privacy{" "}
                                            <Link to={"/privacy-policy-buy-cars"}>
                        Privacy Policy
                                            </Link>{" "}
                      and{" "}
                                            <Link to={"/terms-and-conditions"}>
                        Terms &amp; Conditions
                                            </Link>
                                        </li>
                                        <li>
                      Cars24 NBFC’s{" "}
                                            <span onClick={onClickTermsOfUse}>Terms &amp; Conditions</span> and{" "}
                                            <a
                                                href={TU_CIBIL_PDF}
                                                target="_blank"
                                            >
                        TU CIBIL Terms of Use
                                            </a>
                                        </li>
                                    </ul>
                                </React.Fragment>
                            </div>
                        </React.Fragment>
                    ) : (
                        <div styleName={"styles.formWrap"}>
                            <h4 styleName={"styles.heading"}>Mobile number</h4>
                            <div styleName={"styles.formGroup"}>
                                <InputMobile
                                    isPrefixAsFixed={true}
                                    isLabelShift={false}
                                    placeholder="999 999 9999"
                                    inputRef={phoneRef}
                                    value={custPhone}
                                    onChange={onPhoneChange}
                                    disabled={!isEditable}
                                />
                                {isEditable && (
                                    <span styleName={"styles.edit"} onClick={handleEdit}>
                      EDIT
                                    </span>
                                )}
                            </div>
                            {/* Enter OTP */}
                            <h4 styleName={"styles.heading"}>OTP</h4>
                            <div styleName={"styles.formGroup"}>
                                <InputOTP
                                    inputRef={otpRef}
                                    value={otp}
                                    onChange={onOtpChange}
                                    isLabelShift={false}
                                    placeholder=""
                                />
                                {isOTPInvalid && (
                                    <p styleName={"styles.textError"}>
                                        {errorMessage || "Incorrect OTP, please try again."}
                                    </p>
                                )}
                            </div>
                            <p styleName={"styles.otpSentText"}>
                                {!showResendOtp ? (
                                    <React.Fragment>
                      Resend OTP in
                                        <span className="mr-1 ml-1">
                                            <CountdownTimer
                                                className="mr-1 ml-1"
                                                onlyText={true}
                                                interval={30}
                                                onComplete={onCompleteTimer}
                                            />
                                        </span>
                      seconds
                                    </React.Fragment>
                                ) : (
                                    <span
                                        styleName={"styles.resendOtp"}
                                        role="button"
                                        onClick={onRequestOTP}
                                    >
                      Resend OTP
                                    </span>
                                )}
                            </p>
                            <Button
                                text="VERIFY"
                                onClick={onOtpVerify}
                                disabled={otp.length < bifrost.getOtpLength()}
                                isLoading={showLoader}
                            />
                        </div>
                    )}
                </div>
            </div>
        </Modal>
    );
};

LoginControl.propTypes = {
    heading: PropTypes.string,
    onClose: PropTypes.func,
    showOtpField: PropTypes.bool,
    custPhone: PropTypes.string,
    otp: PropTypes.string,
    otpRef: PropTypes.object,
    phoneRef: PropTypes.object,
    toggleRef: PropTypes.object,
    showLoader: PropTypes.string,
    isNextDisabled: PropTypes.bool,
    onPhoneChange: PropTypes.func,
    onOtpChange: PropTypes.func,
    onGetOTP: PropTypes.func,
    allowWhatsapp: PropTypes.bool,
    errorMessage: PropTypes.string,
    onWhatsappChange: PropTypes.func,
    onOtpVerify: PropTypes.func,
    showResendOtp: PropTypes.func,
    onCompleteTimer: PropTypes.string,
    setShowOtpField: PropTypes.func,
    getEventCategory: PropTypes.func,
    isOTPInvalid: PropTypes.bool,
    setErrorMessage: PropTypes.func,
    carAppId: PropTypes.string,
    cityInfo: PropTypes.object,
    isEditable: PropTypes.bool,
    overlayClass: PropTypes.string
};

export default LoginControl;
